import { FetchConstatGravitiesResponse } from "../../../types/apiResponsesTypes";
import { ConstatGravity } from "../../../types/constatGravities";
import GenericTable from "../GenericTable";
import useTableConstatGravities from "./hooks/useTableConstatGravities";

type Props = {
  data: FetchConstatGravitiesResponse | undefined;
  fetchData: (queryParams?: string) => void;
  isLoading: boolean;
  onModify: (id: number) => void;
  onDelete: (id: number) => void;
};

const TableConstatGravities: React.FC<Props> = ({
  data,
  fetchData,
  isLoading,
  onModify,
  onDelete,
}) => {
  const { columns, onRowClick } = useTableConstatGravities({ onModify, onDelete });

  return (
    <GenericTable<ConstatGravity>
      results={data?.results || []}
      count={data?.count || 0}
      columns={columns}
      fetchData={fetchData}
      isLoading={isLoading}
      onRow={onRowClick}
    />
  );
};

export default TableConstatGravities;
